import React from 'react';
import { config } from '../config';
import Goto from './Goto';
import PublicResult from './PublicResult';
import { useStyles } from './styles';

export interface RedirectProps {
  type: keyof typeof config;
}

/**
 * All redirect triggers.
 */
export default function Redirect({ type }: RedirectProps) {
  const styles = useStyles();

  return (
    <div className={styles.redirectContainer}>
      <Goto className={styles.trigger} />
      {type === 'thankyou' && <PublicResult className={styles.trigger} />}
    </div>
  );
}
